
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renew",
      function () {
        return require("private-next-pages/renew.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renew"])
      });
    }
  